import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import { text } from "./text";
import { scroll } from "./scroll";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0"
  },
  modules: {
    text,
    scroll
  }
};

export default new Vuex.Store<RootState>(store);
